import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Login } from '@components/auth/Login';
import { Register } from '@components/auth/Register';
import { ProtectedRoute } from '@components/auth/ProtectedRoute';
import { Layout } from '@components/layout/Layout';
import { Dashboard } from './pages/Dashboard';
import { CustomerList } from './pages/CustomerList';
import { CustomerDetail } from './pages/CustomerDetail';
import { SessionDetail } from './pages/SessionDetail';
import { CaseQueue } from './pages/CaseQueue';
import { CaseDetail } from './pages/CaseDetail';
import { TelemetryEvents } from './pages/TelemetryEvents';
import { SystemMonitor } from './pages/SystemMonitor';
import { Reports } from './pages/Reports';
import { Settings } from './pages/Settings';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/customers" element={<CustomerList />} />
            <Route path="/customers/:customerId/sessions/:sessionId" element={<SessionDetail />} />
            <Route path="/customers/:id/*" element={<CustomerDetail />} />
            <Route path="/cases" element={<CaseQueue />} />
            <Route path="/cases/:id" element={<CaseDetail />} />
            <Route path="/transactions" element={<div>Transactions (Coming Soon)</div>} />
            <Route path="/cards" element={<div>Cards (Coming Soon)</div>} />
            <Route path="/compliance" element={<div>Compliance (Coming Soon)</div>} />
            <Route path="/telemetry" element={<TelemetryEvents />} />
            <Route path="/system" element={<SystemMonitor />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/settings/*" element={<Settings />} />
          </Route>
        </Route>

        {/* Catch all - redirect to dashboard */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

